import React from 'react';
import { useTranslation } from 'react-i18next';

import { Body } from '@swyftx/aviary/atoms/Typography';

type Props = {
  className?: string;
};

const SwyftxMarginDisclaimer: React.FC<Props> = ({ className }) => {
  const { t } = useTranslation('margin');

  return (
    <Body size='xsmall' color='secondary' className={className}>
      {t('disclaimer')}
    </Body>
  );
};

export { SwyftxMarginDisclaimer };
